import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getUnreadPollCount } from '../../../polls/functions';
import { getUnreadCount } from '../../functions';
import BadgeCounter from '../../../base/toolbox/components/web/BadgeCounter';
import { colors } from '../../../base/ui/Tokens';
/**
 * Implements a React {@link Component} which displays a count of the number of
 * unread chat messages.
 *
 * @augments Component
 */
class ChatCounter extends Component {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (
        // <span className = 'badge-round'>
        //     <span>
        //         {
        //             !this.props._isOpen
        //             && (this.props._count || null)
        //         }
        //     </span>
        // </span>
        React.createElement(React.Fragment, null, this.props._count ?
            React.createElement(BadgeCounter, { count: this.props._count || null, backgroundColor: colors.primary10 }) :
            null));
    }
}
/**
 * Maps (parts of) the Redux state to the associated {@code ChatCounter}'s
 * props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _count: number
 * }}
 */
function _mapStateToProps(state) {
    const { isOpen } = state['features/chat'];
    return {
        _count: getUnreadCount(state) + getUnreadPollCount(state),
        _isOpen: isOpen
    };
}
export default connect(_mapStateToProps)(ChatCounter);
